import { useUpdateUserProfileMutation } from 'api/userApi';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSelectedSiteCollaborateInfo } from '../store/siteInfoSlice';
import { getUser, setUpdateUserName } from '../store/userSlice';

export const useUpdateProfile = () => {
  const dispatch = useDispatch();
  const userInfo = useSelector(getUser);
  const collaborateInfo = useSelector(getSelectedSiteCollaborateInfo);
  // Execute the query
  const [updateUserdetails, { isLoading: isUpdating }] =
    useUpdateUserProfileMutation();
  const handleUpdateUserProfile = useCallback(async () => {
    try {
      const currentEmailPrefix = userInfo?.email.split('@')[0] || '';

      // Check if name is either missing or an email address
      const isNameAnEmail =
        userInfo?.name &&
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userInfo.name.trim());

      // 1. users with no name, use email prefix
      // 2. Otherwise use their entered name
      const nameToUse =
        !userInfo?.name || userInfo?.name.trim() === '' || isNameAnEmail
          ? currentEmailPrefix
          : userInfo?.name;
      const data = {
        data: {
          name: nameToUse,
          workspace_id: String(collaborateInfo?.result?.workspace_id || 0),
        },
        workspace_id: String(collaborateInfo?.result?.workspace_id || 0),
        userId: userInfo?.id,
      };
      dispatch(setUpdateUserName(nameToUse));
      await updateUserdetails(data).unwrap();
    } catch (error) {
      console.error('Error updating user profile', error);
      // dispatch(setUpdateUserName(false));
    }
  }, [userInfo, collaborateInfo, updateUserdetails, dispatch]);

  return {
    handleUpdateUserProfile,
    isUpdating,
  };
};
